/* @flow */
import BaseModel from "nexia_mobile/models/base_model";
import Editable from "nexia_mobile/models/mixins/editable";
import Environment from "nexia_mobile/environment";
import LocalSettings from "nexia_mobile/models/local_settings";

class Phone extends BaseModel {
  initialize() {
    super.initialize();
  }

  activationCode() {
    return this.postCommand("activation_code", {
      method: "PUT",
      data: JSON.stringify({
        /* eslint-disable camelcase */
        is_amstd: Environment.isAmStdCommercial(),
      }),
    }).then((response) => {
      this.set({
        activationKey: response.activation_key,
      });
      return this.fetch();
    });
  }

  setLocale(locale, setLocaleContext, setUserLocaleContext) {
    return this.postCommand("locale", {
      method: "POST",
      data: JSON.stringify({
        locale,
      }),
    }).then((response) => {
      this.set({
        locale: response.locale,
      });
      LocalSettings.setLocale(response.locale);
      setLocaleContext(response.locale);
      setUserLocaleContext(response.locale);
      return this.fetch();
    });
  }
}
_.extend(Phone.prototype, Editable);
export default Phone;



// WEBPACK FOOTER //
// ./src/models/phone.js